"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalOrderInvoiced = void 0;
const getTotalOrderInvoiced = (order) => {
    if (!order)
        return 0;
    if (!order.transactions)
        return 0;
    return order.transactions
        .filter((t) => t.type === "INVOICE" && !t.reversal_date)
        .reduce((acc, cur) => {
        return acc + cur.amount;
    }, 0);
};
exports.getTotalOrderInvoiced = getTotalOrderInvoiced;
